module.exports = __webpack_public_path__ + "47527b600b9ced869533209b385b2c07.svg";